import { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketQuickAnswers = ({ dispatch }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();



  //  ****************
  //  ** Use Effect **
  //  ****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const handleQuickAnswer = (data) => {
        if ((data.action === "update" || data.action === "create") && (`${api.defaults.headers.tenantId.toString()}` === `${data.tenantId.toString()}`)) {
          dispatch({ type: "UPDATE_QUICK_ANSWERS", payload: data.quickAnswer });
        }
  
        if ((data.action === "delete") && (`${api.defaults.headers.tenantId.toString()}` === `${data.tenantId.toString()}`)) {
          dispatch({
            type: "DELETE_QUICK_ANSWERS",
            payload: +data.quickAnswerId,
          });
        }
      };
  
      socket.on("quickAnswer", handleQuickAnswer);
  
      return () => {
        socket.off("quickAnswer", handleQuickAnswer);
      };
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);


  
  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketQuickAnswers;